// extracted by mini-css-extract-plugin
export default {"addToCartButton":"cart_addToCartButton__ccBKQ","addToCartButtonSmall":"cart_addToCartButtonSmall__R0n4d"};